// Illuminate username rules: /^[a-zA-Z0-9]([a-zA-Z0-9'\-_|@.]*[a-zA-Z0-9])?$/,
// at most 100 characters. Split into separate checks so each can have its own message.

export const USERNAME_MAX_LENGTH = 100;

const ALPHANUMERIC = /^[a-zA-Z0-9]$/;
const ALLOWED_CHARACTER = /^[a-zA-Z0-9'\-_|@.]$/;

export type UsernameProblem =
    | { kind: 'required' }
    | { kind: 'tooLong' }
    | { kind: 'firstCharInvalid' }
    | { kind: 'lastCharInvalid' }
    /** Distinct invalid characters, sorted. */
    | { kind: 'invalidCharacters'; characters: string[] };

/** The first rule the username breaks, if any. */
export const usernameProblem = (value: string): UsernameProblem | undefined => {
    if (!value.length) return { kind: 'required' };
    if (value.length > USERNAME_MAX_LENGTH) return { kind: 'tooLong' };
    if (!ALPHANUMERIC.test(value[0])) return { kind: 'firstCharInvalid' };
    if (!ALPHANUMERIC.test(value[value.length - 1])) {
        return { kind: 'lastCharInvalid' };
    }
    const characters = [
        ...new Set([...value].filter(char => !ALLOWED_CHARACTER.test(char))),
    ].sort();
    if (characters.length) return { kind: 'invalidCharacters', characters };
    return undefined;
};
